import { createAsyncThunk } from "@reduxjs/toolkit"

export const setCurrentPage = (featureName) => {
  return createAsyncThunk(
    `${featureName}/pagination/setCurrentPage`,
    async (options) => {
      return options
    }
  )
}
